import React, { Component } from 'react';

class Label extends Component {
  render() {
    return (
      <label {...this.props} className={`label ${this.props.className}`}>
        {this.props.children}
      </label>
    );
  }
}

export default Label;
